/** Adaptive decimals for sub-cent alts (GALA ~0.0017) vs BTC. */
export const priceDigits = (n: number): number => {
  const a = Math.abs(Number(n));
  if (!Number.isFinite(a) || a === 0) return 4;
  if (a >= 1000) return 2;
  if (a >= 100) return 3;
  if (a >= 1) return 4;
  if (a >= 0.1) return 5;
  if (a >= 0.01) return 5;
  if (a >= 0.001) return 6;
  if (a >= 0.0001) return 7;
  return 8;
};

export const minMoveFor = (digits: number): number => {
  const d = Math.min(8, Math.max(2, digits));
  return Number(`1e-${d}`);
};

export const fmtPrice = (n: number, digits?: number): string => {
  const x = Number(n);
  if (!Number.isFinite(x)) return '—';
  const d = digits ?? priceDigits(x);
  return x.toLocaleString('en-US', { minimumFractionDigits: Math.min(2, d), maximumFractionDigits: d });
};

export const fmtVol = (n: number): string => {
  const x = Number(n);
  if (!Number.isFinite(x)) return '—';
  if (Math.abs(x) >= 1e6) return `${(x / 1e6).toFixed(2)}M`;
  if (Math.abs(x) >= 1e3) return `${(x / 1e3).toFixed(2)}K`;
  return x.toLocaleString('en-US', { maximumFractionDigits: 2 });
};
